(function ($) {
    const $modal = $('#oav-manage-modules-modal');

    if ($modal.length === 0) {
        return;
    }

    $modal.on('hidden.bs.modal', function () {
        $('#modal-title').html('');
        $('#modal-body').html('');
    });

    $('.add-offer, .edit-offer, .edit-modules').click(function () {
        const $self = $(this);
        const ajaxUrl = $self.attr('data-ajax-url');
        const modalTitle = $self.attr('data-modal-title');
        $('#modal-title').html(modalTitle);
        $('#modal-body').load(ajaxUrl);
    })

    $('.delete-offer').click(function () {
        Swal.fire({
            title: 'Êtes-vous sûr de vouloir supprimer ?',
            showCancelButton: true,
            confirmButtonText: 'Oui',
            cancelButtonText: 'Annuler',
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        }).then(result => {
            if (!result.isConfirmed) {
                return;
            }
            const $self = $(this);
            const offerId = $self.attr('data-id');
            const ajaxUrl = $self.attr('data-ajax-url');
            $.ajax({
                url: ajaxUrl,
                type: 'DELETE',
                data: {
                    'id': offerId,
                    '_token': $('meta[name="csrf-token"]').attr('content'),
                },
                success: function () {
                    $self.closest('.dropdown').remove();
                }
            });
        });
    });

})($);
